export enum UserRole {
  EXAM_TAKER = 'ExamTaker',
  ANALYST = 'Analyst',
  CONTRIBUTOR = 'Contributor',
  MODERATOR = 'Moderator',
  ADMINISTRATOR = 'Administrator',
};